// extracted by mini-css-extract-plugin
export default {"tittle":"Skills_tittle__mdl1q","skillsWrapper":"Skills_skillsWrapper__dUm2f","skillsImg":"Skills_skillsImg__lKV3S"};